module.exports = __webpack_public_path__ + "media/owl.1de06455.webm";